import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";

import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";

export const Layout = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* WS11: skip link — visible solo con foco de teclado */}
      <a
        href="#main-content"
        data-testid="skip-to-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-[#0A0A0A] focus:text-white focus:px-4 focus:py-2 focus:rounded-full focus:text-sm"
      >
        {t("a11y.skipToContent")}
      </a>
      <Header />
      <motion.main
        id="main-content"
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        className="flex-1 pt-11"
      >
        <Outlet />
      </motion.main>
      <Footer />
    </div>
  );
};
